import React, { useEffect, useState } from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'
import { Link as RouterLink, useLocation } from 'react-router-dom'

import { PageHeaderDrawer } from '../page-header-drawer'
import { ChargeAmpsLandingPageLogo } from '../charge-amps-landing-page-logo'
import { currentCompany, Company } from '../current-company'
import { FortumLandingPageLogo } from '../fortum-landing-page-logo'

const Container = styled.div<{ scrolled: boolean }>`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:after {
        position: absolute;
        content: '';
        right: 0;
        left: 0;
        bottom: 0;
        height: 1px;
        background-color: ${({ theme, scrolled }) => (scrolled ? theme.brandColors.CA_Light_Gray : 'transparent')};
        transition: background-color 0.2s;
    }
`
export const Link = styled.a<{ selected?: boolean; light?: boolean }>`
    color: ${({ theme, selected, light }) => {
        if (selected) return theme.font.midLightColor
        if (light) return theme.font.lightestColor

        return theme.font.midDarkColor
    }};
    transition: all 0.2s ease;
    letter-spacing: 0.01em;
    text-decoration: none;
    cursor: pointer;

    :hover {
        color: ${({ theme, selected }) => (selected ? theme.font.midLightColor : theme.font.successColor)};
        text-decoration: none;
    }

    :focus {
        text-decoration: none;
        color: ${({ theme, selected }) => (selected ? theme.font.midLightColor : theme.font.midDarkColor)};
    }
`

export type LinkType = {
    labelCode: string
    href?: string
    displayLabelCode?: string
    onClick?: React.MouseEventHandler<HTMLAnchorElement>
    prefetch?: () => void
    subMenu?: LinkType[]
    hasNotification?: boolean
}

export type PageHeaderProps = {
    links: LinkType[]
    className?: ClassName
    style?: React.CSSProperties
}

export function PageHeader({ className, style, links }: PageHeaderProps): React.ReactElement {
    const [scrolled, setScrolled] = useState(false)

    const { pathname } = useLocation()

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY !== 0)

        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    })

    return (
        <Container className={cn(className)} style={style} scrolled={scrolled} data-testid="header-container">
            <div data-testid="caLogo">
                {currentCompany !== Company.FORTUM ? (
                    <RouterLink
                        to={'/dashboard'}
                        onClick={() => {
                            if (pathname === 'dashboard') window.scrollTo(0, 0)
                        }}
                    >
                        <ChargeAmpsLandingPageLogo />
                    </RouterLink>
                ) : (
                    <FortumLandingPageLogo color="#5AC37D" />
                )}
            </div>

            <PageHeaderDrawer links={links} />
        </Container>
    )
}
